//@flow

import React from 'react';

import TOC from '../TOC';

type Props = {
  TOCTitles: Array<String>,
};

const SideMenuWithTOC = (props: Props) => (
  <div
    className="fix-menu d-block d-md-none"
    id="slideout-toc"
    onClick={() => {
      document.getElementById('slideout_inner-toc').classList.toggle('open-innermenu-toc');
      document.getElementById('slideout-toc').classList.toggle('open-menu-toc');
      document.getElementById('slideout-toc').classList.toggle('change');
    }}
  >
    <div className="bar1" />
    <div className="bar2" />
    <div className="bar3" />
    <div id="slideout_inner-toc" className="">
      <TOC {...props} />
    </div>
  </div>
);

export default SideMenuWithTOC;



// WEBPACK FOOTER //
// ./src/components/SideMenuWithTOC/SideMenuWithTOC.js